import React, { useState, useEffect } from 'react'
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import firebase from 'firebase';
import { firestore, signInWithGoogle } from '../../firebase/firebase-utils';
import { withRouter, Redirect } from 'react-router-dom';
import Terms from '../../assets/terms.pdf'

const FreelanceForm = (props) => {
    const [submitState, setSubmitState] = useState(false);
    const [progress, setprogress] = useState(0);
    const [show, setShow] = useState(false);
    const [error, seterror] = useState(false);
    const [uploaded, setuploaded] = useState(false);
    let [files, setfiles] = useState(0);
    const [terms, setterms] = useState(false);
    const [name, setname] = useState('');
    const [email, setemail] = useState('');
    const [phone, setphone] = useState('');
    const [project, setproject] = useState('');
    const [discrp, setdiscrp] = useState('');

    useEffect(() => {
        if (name === '' || email === '' || project === '' || discrp === '' || files === 0 || terms === false || error === true) {
            setSubmitState(false)
        }
        else {
            setSubmitState(true);
        }
    }, [name, email, phone, discrp, project, files, error, terms]);

    const orderHandler = () => {
        setShow(true)
        let query = Date.now();
        let timestamp = new Date();
        let current_m = ("0" + (timestamp.getMonth() + 1)).slice(-2);
        let current_d = ("0" + timestamp.getDate()).slice(-2);
        let current_y = timestamp.getFullYear()
        let orderDate = current_d + "-" + current_m + "-" + current_y;
        firestore.collection('Orders').doc().set({
            name: name,
            email: email,
            phone: phone,
            project: project,
            discrp: discrp,
            orderTime: query,
            orderDate: orderDate,
            category: props.category,
            status: 20,
            rating:'',
            review:'',
            uEmail: props.user.email,
            userId: props.user.uid,
            uImg: props.user.photoURL
        })
            .then(upload())
    }

    const upload = () => {
        let files = document.getElementById('files').files;
        for (let i = 0; i < files.length; i++) {
            uploadfile(files[i])
        }
    }

    const uploadfile = (file) => {
        let storageRef = firebase.storage().ref(`files/${project}/${file.name}`);

        let uploadTask = storageRef.put(file);

        uploadTask.on('state_changed', (snapshot) => {
            let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setprogress(Math.floor(progress))
        }, (error) => {
            console.log(error.message);
        }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                files = files - 1
                if (files === 0) {
                    setuploaded(true)
                }
            })
        })
    }

    const fileHandler = (e) => {
        let files = e.target.files;
        setfiles(files.length)
        let size = 0;
        for (let i = 0; i < files.length; i++) {
            size = size + files[i].size;
        }
        if (size < 25000000) {
            seterror(false)
        }
        else {
            seterror(true)
        }
    }


    return (
        <div className="freelance-order-form" style={{ backgroundColor: '#fff', padding: '20px' }}>
            <Modal show={show} size="sm" style={{ padding: '30px' }}>
                <div class="spinner-border" style={{ width: '3rem', height: '3rem', margin: '20px auto', padding: '5px' }} role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <h6 style={{ margin: '20px auto' }}>{progress > 0 ? 'Uploading Files...' : 'Processing your request...'}</h6>
            </Modal>
            {uploaded ? <Redirect to="/freelance/myOrders" /> : null}
            <h4>Place new order</h4>
            <br />
            <Form>
                {/* Name */}
                <Form.Group controlId="formBasicEmail">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" placeholder="your name / company name" onChange={(e) => setname(e.target.value)} required />
                </Form.Group>

                {/* Email  */}
                <Form.Group controlId="formBasicEmail">
                    <Row>
                        <Col sm={12} md={6}>
                            <Form.Label>Email address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email to contact..." onChange={(e) => setemail(e.target.value)} required />
                        </Col>
                        <Col sm={12} md={6}>
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control type="number" placeholder="(Optional)" onChange={(e) => setphone(e.target.value)} />
                        </Col>
                    </Row>

                </Form.Group>

                {/* project name */}
                <Form.Group controlId="formBasicEmail">
                    <Form.Label>Project title</Form.Label>
                    <Form.Control type="text" placeholder="Give a title for this project..." onChange={(e) => setproject(e.target.value)} required />
                </Form.Group>

                {/* text area for project idea  */}
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Describe your Idea</Form.Label>
                    <Form.Control as="textarea" rows={3} maxLength='150' placeholder="Write a brief note about your project idea..." onChange={(e) => setdiscrp(e.target.value)} required />
                </Form.Group>

                {/* upload files  */}
                <Form.Group>
                    <Form.Label>File upload</Form.Label>
                    <Form.File multiple id="files" onChange={fileHandler} style={{ padding: '20px', border: '1px solid gray' }} required />
                    <Form.Text className="text-muted" style={{ color: 'tomato' }}>
                        Note: You must include a text/word document describing detailed information about your project idea. {props.category === 'Others' ? null : 'See the demo document for refferrence.'}
                    </Form.Text>
                    {error ? <Form.Text><p style={{ color: 'red' }}>File size limited to 25 mb</p></Form.Text> : null}
                </Form.Group>
                {/* terms and conditions */}
                <Form.Group controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" label={<a href={Terms} target="_blank" rel="noreferrer">Terms and conditions</a>} onChange={(e) => setterms(e.target.checked)} />
                </Form.Group>

                {/* submitbtn */}
                <Button variant="primary" disabled={!submitState} onClick={props.user ? orderHandler : signInWithGoogle} style={{ backgroundColor: '#057BD0' }}>
                    Submit
                </Button>
            </Form>
        </div>
    )
}

export default withRouter(FreelanceForm);
